// extracted by mini-css-extract-plugin
export default {"textTitle":"UserMenuBalance_textTitle--hqP","userMenuTitle":"UserMenuBalance_userMenuTitle--BLH"};